<template style="overflow: visible; z-index: 300">
  <v-dialog
    style="z-index: 9999;"
    @keydown.esc="isOpen=false"
    v-model="isOpen"
    max-width="450">
    <v-card>
      <v-card-title>
        Subir XML
      </v-card-title>
      <v-card-text>
        <v-file-input
          v-model="xmlFile"
          dense
          hide-details
          accept=".xml"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          @click="closeUploadXMLDialog">
          Cancelar
        </v-btn>
        <v-btn
          :disabled="disabled"
          color="primary"
          rounded
          small
          depressed
          @click="uploadXML">
          Subir XML
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    orders: {
      type: Array
    }
  },
  data () {
    return {
      isOpen: false,
      xmlFile: null,
      overlayCreateByXML: false,
      disabled: false
    }
  },
  methods: {
    uploadXML: async function () {
      this.overlayCreateByXML = true
      try {
        const payload = {
          xmlFile: this.xmlFile,
          orders: this.orders.map(payOrder => payOrder._id)
        }
        await this.$api.post(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}/attach-invoice`, payload, { delivery: 'formData' })
        this.$toasted.show('Se anexó correctamente la factura.', { duration: 3000 })
        this.closeUploadXMLDialog()
        this.$emit('refresh')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlayCreateByXML = false
    },
    closeUploadXMLDialog () {
      this.xmlFile = null
      this.isOpen = false
      this.$emit('close', false)
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
